import clsx from 'clsx';

type NewPillTagProps = {
	variant?: 'dark' | 'light';
};

export function NewPillTag({ variant = 'dark' }: NewPillTagProps) {
	return (
		<span
			className={clsx(
				'inline-flex shrink-0 items-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold uppercase leading-none tracking-wide',
				{
					'bg-emerald-100 text-emerald-700': variant === 'light',
					'bg-emerald-400/20 text-emerald-300': variant === 'dark',
				}
			)}
		>
			New
		</span>
	);
}
